<div id="search-component">

  <input class="form-control" type="text" placeholder="Search..." #searchBox id="search-box" (input)="search(searchBox.value)" />

  <div class="m-2" *ngIf="searchBox.value != ''">
    <div class="row border d-none d-sm-flex" *ngIf="trips$ | async">
      <div class="col-sm-2"><strong>Train</strong></div>
      <div class="col-sm-2"><strong>Line</strong> </div>
      <div class="col-sm-2"><strong>Origin</strong></div>
      <div class="col-sm-2"><strong>Destination</strong></div>
      <div class="col-sm-2"><strong>Next</strong></div>
      <div class="col-sm-2"><strong>Delay</strong></div>
    </div>
    <div class="row border" *ngFor="let trip of trips$ | async">
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Train:</strong></div><a  class="btn btn-link" routerLink="/trip/detail/{{trip.id}}">{{ trip.id }}</a></div>
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Line:</strong></div> {{ trip.route.replace('/', ' ') }}</div>
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Origin:</strong></div> {{ trip.origin }}</div>
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Destination:</strong></div> {{ trip.destination }}</div>
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Next:</strong></div> {{ trip.nextstop }}</div>
      <div class="col-sm-2"><div class="d-inline d-sm-none"><strong>Delay:</strong></div> {{ trip.status }}</div>
    </div>
  </div>
</div>
